/*
 * When loading sources directly with <script type="module"> remove the line below
 * (keep only the export line)
 */
import $ from 'jquery';

export default $;



// WEBPACK FOOTER //
// ./imageLoader/jquery.js